import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import Skeleton from 'react-loading-skeleton'

const carddata = [
  {
    chainicon: "/images/XRP.png",
    chainhead: "XRP",
    todayupto: "+2.11%",
    summarymethod: {
      status: "active",
    },
    sell: "10",
    neutral: "2",
    buy: "14",
  },

  {
    chainicon: "/images/Dogecoin.png",
    chainhead: "Dogecoin",
    todayupto: "+3.33%",
    summarymethod: {
      status: "inactive",
    },
    sell: "10",
    neutral: "2",
    buy: "3",
  },

  {
    chainicon: "/images/Cardona.png",
    chainhead: "Cardona",
    todayupto: "+2.35%",
    summarymethod: {
      status: "neutral",
    },
    sell: "10",
    neutral: "2",
    buy: "14",
  },

  {
    chainicon: "/images/XRP.png",
    chainhead: "XRP",
    todayupto: "+2.11%",
    summarymethod: {
      status: "active",
    },
    sell: "10",
    neutral: "2",
    buy: "14",
  },

  {
    chainicon: "/images/Dogecoin.png",
    chainhead: "Dogecoin",
    todayupto: "+3.33%",
    summarymethod: {
      status: "inactive",
    },
    sell: "10",
    neutral: "2",
    buy: "3",
  },

  {
    chainicon: "/images/Cardona.png",
    chainhead: "Cardona",
    todayupto: "+2.35%",
    summarymethod: {
      status: "neutral",
    },
    sell: "10",
    neutral: "2",
    buy: "14",
  },

  {
    chainicon: "/images/XRP.png",
    chainhead: "XRP",
    todayupto: "+2.11%",
    summarymethod: {
      status: "active",
    },
    sell: "10",
    neutral: "2",
    buy: "14",
  },

  {
    chainicon: "/images/Dogecoin.png",
    chainhead: "Dogecoin",
    todayupto: "+3.33%",
    summarymethod: {
      status: "inactive",
    },
    sell: "10",
    neutral: "2",
    buy: "3",
  },

  {
    chainicon: "/images/Cardona.png",
    chainhead: "Cardona",
    todayupto: "+2.35%",
    summarymethod: {
      status: "neutral",
    },
    sell: "10",
    neutral: "2",
    buy: "14",
  },
];

const Trending = ({ settingInfo, loading }) => {
  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 5.1,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1169,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
          initialSlide: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };
  /**
     * Used for render the UI on home page
     */
  return (
    <>
      <section className="Trending_section">
        <Container>
          <div className="heading_Common_toall position-relative">

            {
              loading ? <Skeleton width={"80%"} height={26} /> : <h2 className="heading_common mb-3">{settingInfo?.heading1}</h2>}
            {
              loading ? <Skeleton width={"80%"} height={26} /> : <p>
                {settingInfo?.heading2}
              </p>}

          </div>
        </Container>

        {/* <div className="trendingslider mt-5">
          <Slider {...settings}>
            {carddata.map((carditem, idx) => {
              const {
                chainicon,
                chainhead,
                todayupto,
                summarymethod,
                sell,
                neutral,
                buy,
              } = carditem;

              return (
                <div className="trending_card" key={idx}>
                  <div className="trending_top d-flex justify-content-between align-items-center border-bottom pb-3">
                    <div className="trending_icon_left d-flex justify-content-between align-items-center">
                      <div className="chain_icon me-2">
                        <img src={chainicon} alt="" className="img-fluid" />
                      </div>
                      <div className="chain_content text-start">
                        <h5>{chainhead}</h5>
                        <p>
                          Today up to{" "}
                          <span className="green_col">{todayupto}</span>
                        </p>
                      </div>
                    </div>
                    <div className="trending_graph_right">
                      <img
                        src="/images/Chartgreen.png"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </div>

                  <div className="trending_bottom pt-3">
                    <ul className="d-flex p-0 m-0 justify-content-between">
                      <li>
                        <p>Summary</p>
                        {summarymethod.status === "active" && (
                          <p className="green_col">Strong Buy</p>
                        )}
                        {summarymethod.status === "inactive" && (
                          <p className="red_col">Strong Sell</p>
                        )}
                        {summarymethod.status === "neutral" && (
                          <p className="black_col">Neutral</p>
                        )}
                      </li>

                      <li>
                        <p>Sell</p>
                        <p className="red_col">{sell}</p>
                      </li>

                      <li>
                        <p>Neutral</p>
                        <p className="black_col">{neutral}</p>
                      </li>

                      <li>
                        <p>Buy</p>
                        <p className="theme_col">{buy}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div> */}
      </section>
    </>
  );
};

export default Trending;
